module.exports = __webpack_public_path__ + "static/media/yellowUncheck.4c57b8e2.svg";